<template>
  <div class="multi-account-modal">
    <div class="text-center q-mt-lg">
      <QImg :src="picture" class="modal-picture" />
    </div>
    <section>
      <h2 class="q-mt-xl text-center ">
        {{ $t('ETAB.PAGES.MULTI_ACCOUNT.@MODAL_TITLE') }}
      </h2>
      <p class="q-mt-md text-center text-italic">
        {{ $t('ETAB.PAGES.MULTI_ACCOUNT.@MODAL_DESCRIPTION') }}
      </p>
    </section>
    <section class="multi-account-modal-btn text-center q-mt-xl">
      <QBtn
:label="$t('ETAB.PAGES.MULTI_ACCOUNT.@MODAL_CANCEL')"
            flat
            @click="onClickBack"
      />
      <QBtn
        :label="$t('ETAB.PAGES.MULTI_ACCOUNT.@MODAL_CONTACT')"
        color="secondary"
        @click="openTypeform(typeformLink)"
      />
    </section>
  </div>
</template>

<script>
import { ETAB_ROUTES } from "@etab/config";
import img from "@core/assets/img/keys.svg";
import { typeformMixins } from "@core/mixins/typeform.mixins";

export default {
  mixins: [typeformMixins],
  props: {
    typeformLink: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      picture: img,
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: ETAB_ROUTES.userMenu.root.name }).catch(suppressedError => {});
    },
    openTypeform(typeformUrl, options = {}) {
      this.$_typeformOpenPopup(typeformUrl, options);
    },
  },
};
</script>

<style lang="scss">
.multi-account-modal {
  .modal-picture {
    width: 150px;
  }
  .multi-account-modal-btn {
    display: flex;
    justify-content: space-around;
  }
}
</style>
